import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'

const noticeCenter: RouteRecordRaw = {
  path: '/notice-center',
  name: 'NoticeCenter',
  redirect: '/notice-center/list',
  component: Layout,
  meta: {
    title: '消息中心'
  },
  children: [
    {
      path: 'list',
      name: 'NoticeCenterList',
      component: () => import('@/views/NoticeCenter/NoticeCenter.vue'),
      meta: {
        title: '消息中心',
        showGuideIcon: true,
        hideInMenu: true
      }
    }
  ]
}

export default noticeCenter
